import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Scatter chart type
 * Extends the base chart configuration
 */
export const scatterChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'scatter'
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 5,
                states: {
                    hover: {
                        enabled: true,
                        lineColor: 'rgb(100,100,100)'
                    }
                }
            },
            states: {
                hover: {
                    marker: {
                        enabled: false
                    }
                }
            }
        }
    },
    tooltip: {
        headerFormat: '<b>{series.name}</b><br>',
        pointFormat: 'x: {point.x}, y: {point.y}'
    },
    // For scatter plots, we often want to show both axes
    xAxis: {
        gridLineWidth: 1,
        title: {
            text: 'X Axis'
        }
    },
    yAxis: {
        gridLineWidth: 1,
        title: {
            text: 'Y Axis'
        }
    }
} as Options);